import { Company as CompanyModel } from '@models/Company'
import {
  getCompanies,
  selectCompanies,
  setCompanyQuery,
} from '@store/CompanyReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { extractSortDataFromSorterResult } from '@utils/table/sorter'
import { Checkbox, Flex, TableColumnsType } from 'antd'
import { TableProps } from 'antd/es/table'
import { useEffect } from 'react'

const CompaniesPage = () => {
  const dispatch = useAppDispatch()

  const items = useAppSelector(selectCompanies())
  const { query, isLoading } = useAppSelector((state) => state.company)
  const { isOpen } = useSBRM()

  const columns: TableColumnsType<CompanyModel> = [
    {
      key: 'name',
      title: 'Nom',
      render: (_, record) => record.name,
    },
    {
      key: 'campaignsOnlyVisibleBySuperAdmin',
      title: 'Entretiens visibles uniquement par les super-admins',
      render: (_, record) => (
        <Checkbox checked={record.campaignsOnlyVisibleBySuperAdmin} disabled />
      ),
    },
    {
      key: 'actions',
      align: 'right',
      render: (_, record) => (
        <SBRM.Actions
          actions={[SBRMAction.Update, SBRMAction.Delete]}
          entity={Entity.company}
          entityId={record.id}
        />
      ),
    },
  ]

  const handleTableChange: TableProps<CompanyModel>['onChange'] = (
    pagination,
    filters,
    sorter
  ) => {
    const newQuery: TableParams = {
      pagination,
      filters,
      ...extractSortDataFromSorterResult(sorter),
    }
    dispatch(setCompanyQuery(newQuery))
    dispatch(getCompanies(newQuery))
  }

  useEffect(() => {
    dispatch(getCompanies(query))
  }, [dispatch, isOpen])

  return (
    <Flex vertical>
      <PageTitle
        title="Sociétés"
        level={5}
        toolbar={
          <SBRM.Actions entity={Entity.company} actions={[SBRMAction.Create]} />
        }
      />
      <SBTable
        scroll={{ x: 600 }}
        columns={columns}
        dataSource={items}
        pagination={query.pagination}
        loading={isLoading}
        onChange={handleTableChange}
      />
    </Flex>
  )
}

export default CompaniesPage
